import React from 'react';
import { UnmountClosed } from 'react-collapse';
import { t } from 'Src/i18n';
import { isRecommendedTransport } from 'Utils/proposal/proposalUtils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { Badge } from 'Components/frameworks/badge/Badge';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { TransportTicket } from 'Components/widgets/be-transport-details/TransportTicket';
type AdditionalTransportSelectedTransportProps = {
  proposal: Proposal;
  selectedTransport: Transport;
};
export const AdditionalTransportSelectedTransport = ({
  proposal,
  selectedTransport,
}: AdditionalTransportSelectedTransportProps) => {
  const { isTablet } = useResponsive();
  const [toggleSelectedTransport, setToggleSelectedTransport] = React.useState(false);
  const isTransportRecommended = isRecommendedTransport(selectedTransport, proposal.id);
  const theme = !isTablet ? 'mobile' : 'desktop';
  return (
    <div data-testid="AdditionalTransportSelectedTransport">
      <button
        data-testid="ToggleSelectedTransportButton"
        type="button"
        onClick={() => setToggleSelectedTransport(!toggleSelectedTransport)}
        className="flex w-full items-center justify-between"
      >
        <div className="flex items-center gap-10 text-14 font-semibold">
          <Badge
            className="size-48 border-black bg-black text-white"
            iconName={ICONS.ALL_INCLUSIVE}
            variant="pill"
          />
          {t('booking.transport.selectedFlight.title')}
        </div>
        <Icon name={ICONS.ARROW_TOP} rotation={toggleSelectedTransport ? 0 : 180} />
      </button>
      <UnmountClosed isOpened={toggleSelectedTransport}>
        <div className="py-15">
          <TransportTicket
            theme={theme}
            isTransportRecommended={isTransportRecommended}
            transport={selectedTransport}
            isSelected
          />
        </div>
      </UnmountClosed>
    </div>
  );
};
